import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const token = localStorage.getItem('chroma-token');

  if (token) {
    // Hay token, déjalo pasar al Dashboard
    return true;
  } else {
    // NO hay token, mándalo al Login inmediatamente
    router.navigate(['/login']);
    return false;
  }
};